import { useEffect, useState } from "react";
import { checkDeductionValidation } from "../functions/deducation";

export const useDeductionValidation = (products) => {
  const [isValid, setIsValid] = useState(true);
  useEffect(() => {
    checkDeductionValidation(products) ? setIsValid(true) : setIsValid(false);
    console.log("isValid", checkDeductionValidation(products));
  }, [products]);
  return { isValid };
};
